export function HelitecnicaLogo({className}: {className?: string}) {
  return (
    <span className={className}>
      <img
        alt="Helitecnica ERP"
        className="h-full w-full object-contain [.dark_&]:hidden"
        height={99}
        src="/branding/helitecnica-logo.png"
        width={300}
      />
      <img
        alt="Helitecnica ERP"
        className="hidden h-full w-full object-contain [.dark_&]:block"
        height={256}
        src="/branding/helitecnica-logo-white.png"
        width={800}
      />
    </span>
  );
}
